export default __webpack_public_path__ + "static/media/edit@2x.fd975b9d.svg";